__turbopack_context__.v({
  "landscape": "ProductResults-module-scss-module__0tFTLa__landscape",
  "listItem": "ProductResults-module-scss-module__0tFTLa__listItem",
  "listItem--no-results": "ProductResults-module-scss-module__0tFTLa__listItem--no-results",
  "listItem--no-results-filler": "ProductResults-module-scss-module__0tFTLa__listItem--no-results-filler",
  "productList": "ProductResults-module-scss-module__0tFTLa__productList",
  "root": "ProductResults-module-scss-module__0tFTLa__root",
  "show": "ProductResults-module-scss-module__0tFTLa__show",
  "zeroState": "ProductResults-module-scss-module__0tFTLa__zeroState",
  "zeroStateInner": "ProductResults-module-scss-module__0tFTLa__zeroStateInner",
  "zeroStateText": "ProductResults-module-scss-module__0tFTLa__zeroStateText",
});
